import request from '@/utils/request'

export function fetchRoleList (query) {
  return request({
    url: '/auth/api/role/index',
    method: 'get',
    params: query
  })
}

export function fetchRole (id) {
  return request({
    url: '/auth/api/role/view',
    method: 'get',
    params: { id }
  })
}

export function updateRolePermissions (id, permissions) {
  return request({
    url: '/auth/api/role/permission_update',
    method: 'post',
    params: { id },
    data: { permission: permissions }
  })
}

export function createRole (data) {
  return request({
    url: '/auth/api/role/insert',
    method: 'post',
    data
  })
}

export function updateRole (data) {
  return request({
    url: '/auth/api/role/update',
    method: 'post',
    data
  })
}

export function deleteRole (id) {
  return request({
    url: '/auth/api/role/delete',
    method: 'post',
    params: { id }
  })
}

export function fetchMenuList (query) {
  return request({
    url: '/auth/api/menu/index',
    method: 'get',
    params: query
  })
}

export function updateRoleMenus (id, menus) {
  return request({
    url: '/auth/api/role/menu_update',
    method: 'post',
    params: { id },
    data: { menu: menus }
  })
}

export function fetchRoleMenus (roleId) {
  return request({
    url: '/auth/api/role/menu',
    method: 'get',
    params: { id: roleId }
  })
}



// WEBPACK FOOTER //
// ./src/api/role.js